var __jsx = React.createElement;
import { MuscleButton } from '@modules/shared/components/buttons';
import MuscleModal from '@modules/shared/components/modal';
import { useTranslations } from 'next-intl';
import React from 'react';
const ErrorInFlowModal = _ref => {
  let {
    isOpen,
    setIsOpen,
    errorCode,
    dataTestId
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const getErrorMessage = () => {
    switch (errorCode) {
      case 'auth-005':
        return t('REGISTER_UNABLE_TO_SEND_EMAIL_ERROR');
      case 'customer-003':
        return t('REGISTER_ALREADY_REGISTERED_ERROR');
      default:
        return t('REGISTER_VERIFICATION_DEFAULT_ERROR');
    }
  };
  return __jsx(MuscleModal, {
    dataTestId: dataTestId,
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx("div", {
    className: "flex flex-col gap-8 p-2 items-center"
  }, __jsx("div", {
    className: "text-2xl text-primary-main font-bold"
  }, t('REGISTER_VERIFICATION_ERROR_TITLE')), __jsx("div", {
    className: "text-base text-black font-thin w-96 text-center"
  }, getErrorMessage()), __jsx(MuscleButton, {
    dataTestId: dataTestId + "-accept-button",
    variant: "solidMd",
    onClick: () => setIsOpen(false)
  }, t('ACCEPT'))));
};
export default ErrorInFlowModal;